<template>
    <div
        class="flex flex-col gap-1 overflow-hidden pl-2 pt-1"
        :class="[
            {
                'soli-grey': !arg.timeText,
                'white--text': arg.timeText,
            },
        ]"
    >
        <!-- Time -->
        <b
            v-if="arg.timeText"
            class="flex justify-between"
            :class="arg.isMirror ? 'soli-grey' : null"
            >{{ arg.timeText }}
            <div v-if="arg.event.extendedProps.students">
                <v-icon
                    v-if="
                        Object.values(arg.event.extendedProps.students).every(
                            (e) => e.attendance.status
                        )
                    "
                    dense
                    right
                    class="float-right pr-1 white--text"
                    >{{
                        arg.event.extendedProps.cancelled
                            ? "do_not_disturb"
                            : "check_circle"
                    }}</v-icon
                >
            </div>
        </b>
        <small v-if="isPlaceholder(arg)">
            {{
                `Starts ${globalMomentDate(
                    arg.event.extendedProps.displayStart
                )}`
            }}
        </small>
        <!-- Title -->
        <div v-if="arg.event.title" class="lesson-event-title flex flex-col">
            <small
                :class="{
                    'subtitle-2 font-bold': arg.event.extendedProps.group_event,
                    'leading-4': !arg.event.extendedProps.group_event,
                }"
                class="whitespace-nowrap"
            >
                {{
                    `${arg.event.extendedProps.online ? "Online " : ""}${
                        arg.event.title
                    }`
                }}
            </small>
            <!-- Student Name -->
            <div
                class="subtitle-2 font-bold"
                v-if="!arg.event.extendedProps.group_event"
            >
                {{
                    arg.event.extendedProps.student
                        ? arg.event.extendedProps.student.name
                        : null
                }}
            </div>
            <!-- Teacher/Substitute Teacher -->
            <small v-if="!hideLessons" class="flex justify-start align-center"
                >{{ getTeacher(arg.event) }}
            </small>
            <!-- Group Event Data -->
            <div
                v-if="
                    arg.event.extendedProps.group_event &&
                    arg.event.extendedProps.students
                "
                class="flex flex-col"
            >
                <v-divider color="white" class="my-2 mr-2" />
                <small>
                    {{
                        `${
                            arg.event.extendedProps.students.filter(
                                (e) => e.enrolled
                            ).length
                        } / ${
                            arg.event.extendedProps.capacity
                                ? arg.event.extendedProps.capacity
                                : ""
                        } Enrolled`
                    }}
                </small>
                <small>
                    {{
                        `${
                            arg.event.extendedProps.students.filter(
                                (e) => e.attending
                            ).length
                        } Attending`
                    }}
                </small>
            </div>
            <!-- Cancelled/Series Event Data-->
            <small class="flex" v-if="arg.event.extendedProps.series">{{
                `${
                    arg.event.extendedProps.cancelled
                        ? "Cancelled"
                        : arg.event.extendedProps.series.n
                } of ${arg.event.extendedProps.series.series}`
            }}</small>
        </div>
    </div>
</template>

<script>
import GlobalMoment from "../../Mixins/GlobalMoment";

export default {
    mixins: [GlobalMoment],
    props: {
        arg: {
            type: Object,
            default: () => {},
        },
        hideLessons: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isPlaceholder(arg) {
            return arg.event.classNames.includes("weekly-placeholder");
        },
        getTeacher(event) {
            if (
                event.extendedProps.availability &&
                event.extendedProps.teacher?.id !==
                    event.extendedProps.availability?.user_id
            ) {
                return `w/ ${event.extendedProps.teacher.name} (sub)`;
            }
            return `w/ ${event.extendedProps.teacher.name}`;
        },
    },
};
</script>
